<template>
    <div v-bind:class="[classstyle , curError ? 'has-error' : '']">
        <slot></slot>
        <errorinputcomponent v-if="curError" :errors="curError"></errorinputcomponent>
    </div>
</template>

<script>
    import ErrorInputComponent from './ErrorInputComponent';
    export default {
        components: {
            errorinputcomponent: ErrorInputComponent
        },
        props: {
            classstyle: { default: function () { return 'form-group'; }},
            errorinput: { default: function() { return null; }},
            bypasscustomselect: { default: false }
        },
        data: function(){
            return {
                curError: null
            }
        },
        computed: {
        },
        watch: {
            errorinput: function (newval,oldValue) {
                this.errorinput = newval;
                this.curError = newval;
                $(this.$el).find('.form-control,.custom-select').removeClass('is-invalid');
                if (this.curError) {
                    $(this.$el).find('.form-control,.custom-select').addClass('is-invalid');
                }
            }
        },
        mounted(){
            this.curError = this.errorinput;
            if (!this.bypasscustomselect) {
                $(this.$el).find('select.form-control').addClass('custom-select');
            }
            
            $(this.$el).find('.form-control,.custom-select').bind('change keyup', () => {
                this.curError = null;
                $(this.$el).find('.form-control,.custom-select').removeClass('is-invalid');
            });
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    label {font-weight: bold;}
</style>
